const FORMALIZATION_SECTION_ORDER = [
  'customer_data',
  'biometry_and_contract',
  'equipment',
  'payment_model',
] as const

export function isStageReproved(value: Record<string, { status?: string, [key: string]: any }>): string {
  for (const key of FORMALIZATION_SECTION_ORDER) {
    if (value[key]?.status === 'reproved') {
      return key
    }
  }
  return ''
}
